import {_, React, observer, useEffect, classNames, useAsObservableSource, toJS, Fragment, trace, observable} from '@api'
import {useVipLocalStore} from '@modules'
import {WhiteboardFooter} from '~components/ToolsPanel/StatusBar'
import {ZoomMenu2} from '~components/TopPanel/ZoomMenu/ZoomMenu2'
import {CurrentToolPanel, TopPanel} from './components'
import {Renderer} from '@tldraw/core'
import * as css from './WhiteboardRoot.css'
import {useWhiteboardStore, WhiteboardStore, WhiteboardStoreContext, SelectedShapesDimensionsToolbar, SelectedShapesFloatingToolbar, useKeyboardShortcuts, useWhiteboardFlexLayoutTabStore} from '.'
import {FocusButton} from './components/FocusButton'
import {ToolsPanel} from './components/ToolsPanel'

/// region Components

interface MyProps {
}

export const WhiteboardRoot = observer<MyProps>(function WhiteboardRoot(props) {
  const tabStore = useWhiteboardFlexLayoutTabStore(),
    obsProps = useAsObservableSource({...props, tabStore}),
    store = useVipLocalStore((stores) => new WhiteboardStore(stores, obsProps))

  useEffect(() => store.registerEffects(), [])

  // console.log(toJS({snapLines, page, pageState}, {recurseEverything: true}))
  // trace()
  return (
    <WhiteboardStoreContext.Provider value={store}>
      <WhiteboardRootInternal/>
    </WhiteboardStoreContext.Provider>)
})

export const WhiteboardRootInternal = observer(function WhiteboardRootInternal() {
  const store = useWhiteboardStore(),
    {
      pageState, myPageState, page, meta, events, theme, appState: {snapLines}, hideBounds, selectionBoundsCssStyles,
      onContextMenu, onMouseLeave, onMouseMove, onDragEnter, onDragLeave, onDragOver, onDragEnd, onDrop,
      props: {tabStore}, shapeUtils,
      settings: {ui: {gridSize, showGrid, showBindingHandles, isFocusMode, showCloneHandles, showRotateHandles}}, hideHandles, isHideBoundsShape, isHideResizeHandlesShape, hideIndicators
    } = store

  const rWrapper = React.useRef<HTMLDivElement>(null)
  useEffect(() => {
    store.container = rWrapper.current
  }, [rWrapper])

  useKeyboardShortcuts(rWrapper)

  return (
    <div className={classNames(css.root)}
         onContextMenu={onContextMenu}
         onMouseLeave={onMouseLeave}
         onMouseMove={onMouseMove}
      //data-shapes-selected={store.selectedShapes.length}
         data-in-session={store.isInSession}
         data-shift-key={store.shiftKey}
         data-ctrl-key={store.ctrlKey}
         data-meta-key={store.metaKey}
         data-zooming={store.camera.animating}
         data-background={myPageState?.background ?? 'none'}
         onDragEnter={onDragEnter}
         onDragLeave={onDragLeave}
         onDragOver={onDragOver}
         onDrop={onDrop}
         onDragEnd={onDragEnd}
         style={selectionBoundsCssStyles}
    >
      {/*<div className={css.dropPlaceholder}/>*/}
      <div className={css.rendererContainer} ref={rWrapper}>
        {page && pageState && (
        <Renderer
          shapeUtils={shapeUtils} // Required
          page={page}
          pageState={pageState}
          {...events}
          snapLines={snapLines}
          meta={meta}
          id={tabStore.tab.id}
          // containerRef={rWrapper}  // If this is turned on then panning/zooming no longer will work(?)
          grid={gridSize}
          hideGrid={!showGrid}
          hideBounds={hideBounds}
          hideHandles={hideHandles}
          hideResizeHandles={isHideResizeHandlesShape}
          hideIndicators={hideIndicators}
          hideBindingHandles={true} //!showBindingHandles}
          hideCloneHandles={!showCloneHandles}
          hideRotateHandles={!showRotateHandles}
        />)}
      </div>

      <div className={css.ui}>
        {isFocusMode ? (
          <FocusButton/>
        ) : (
           <Fragment>
             <TopPanel className={css.toolbar}/>
             {/*<StyledSpacer />*/}
             <ToolsPanel className={css.toolsPanel}/>
             <CurrentToolPanel className={css.currentToolPanel}/>
             {/*<ZoomMenu2 className={css.zoomMenu}/>*/}
           </Fragment>
         )}
      </div>

      <SelectedShapesFloatingToolbar/>
      <SelectedShapesDimensionsToolbar/>
      {store.settings.ui.isDebugMode && <WhiteboardFooter className={css.footer}/>}
    </div>)
})
/// endregion





// WEBPACK FOOTER //
// ./src/modules/whiteboard/WhiteboardRoot.tsx